import { RecipientHeadingEnum } from "../shared/enums/recipient-heading.enum";
export const RecipientsHeadingLookup = new Map([
    [RecipientHeadingEnum.name, "name"],
    [RecipientHeadingEnum.surname, "surname"],
    [RecipientHeadingEnum.designation, "designation"],
    [RecipientHeadingEnum.organisation, "organisation"],
    [RecipientHeadingEnum.telephone, "telephone"],
    [RecipientHeadingEnum.email, "email"],
    [RecipientHeadingEnum.defaultCommunicationMethod, "defaultCommunicationMethod"]
]);
export class RecipientListConstant {
    // labels
    static addBtnLabel = "Add";
    static editBtnLabel = "Edit";
    static deleteBtnLabel = "Delete";
    // error message
    static metadataPropertyNotSetErrMsg = "property is not set in the recipient metadata, please contact your system administrator.";
    // modal body options
    static modalBodyOptions = {
        size: "xl",
        centered: true,
        backdrop: "static"
    };
}
